export const getShares = (state) => state.sharing.shares;
export const getSharesData = (state) => state.sharing.shares.data;
export const getSharingPagination = (state) => state.sharing.pagination;
export const getSharingSorting = (state) => state.sharing.sorting;
export const getCompleteSharing = (state) => state.sharing;
export const getActiveSharingsType = (state) => state.sharing.pageState.activeSharingsType;
